export default __webpack_public_path__ + "static/media/Long_Green.7c5861d7.png";